import { For, Show, createMemo } from "solid-js";
import type { Component } from "solid-js";
import { useUserListQuery } from "../service";
import { useShellStore } from "@ui/state/shell";
import { TableDate } from "@ui/components/TableDate";
import { formatPhone } from "@utils/formatPhone";

const resolve = <T,>(input: T | (() => T)): T => (typeof input === "function" ? (input as () => T)() : input);

// formatDate removed - using TableDate component instead

export const UserListView: Component = () => {
  const query = useUserListQuery();
  const {
    state,
    actions: { selectUser },
  } = useShellStore();

  const users = createMemo(() => resolve(query.data) ?? []);
  const isLoading = () => resolve(query.isLoading);
  const isFetching = () => resolve(query.isFetching);

  return (
    <section class="chat-list-view">
      <header class="chat-list-header">
        <div>
          <h1 class="main-placeholder-title">Customer directory</h1>
          <p>Review contact information, engagement stats, and recent activity.</p>
        </div>
        <div class="chat-list-actions">
          <button
            type="button"
            class="button-primary refresh-button"
            onClick={() => void query.refetch()}
            disabled={isFetching()}
            title="Refresh"
          >
            <i class={`fa-solid fa-rotate-right ${isFetching() ? "spinning" : ""}`}></i>
          </button>
        </div>
      </header>

      <Show when={!isLoading()} fallback={<div class="placeholder-card">Loading customers...</div>}>
        <Show when={users().length > 0} fallback={<div class="placeholder-card">No users registered yet.</div>}>
          <table class="chat-table">
            <thead>
              <tr>
                <th>Name</th>
                <th class="mobile-hide">Email</th>
                <th class="mobile-hide">Phone</th>
                <th>Cleanings</th>
                <th>Joined</th>
              </tr>
            </thead>
            <tbody>
              <For each={users()}>
                {(user) => {
                  const truncatedId = user.id.length > 8 ? `${user.id.slice(0, 8)}...` : user.id;
                  // If displayName equals the ID, show truncated version
                  const displayText = user.displayName === user.id ? truncatedId : user.displayName;
                  return (
                    <tr
                      class={state.selectedUserId === user.id ? "is-selected" : ""}
                      onClick={() => selectUser(user.id)}
                    >
                      <td class="chat-user">
                        <div class="user-name-cell">
                          <div class="user-name-cell-primary">{displayText}</div>
                          <div class="user-name-cell-secondary mobile-only">
                            {user.email || formatPhone(user.phoneNumber) || "-"}
                          </div>
                        </div>
                      </td>
                      <td class="chat-preview mobile-hide">{user.email || "-"}</td>
                      <td class="mobile-hide">{formatPhone(user.phoneNumber)}</td>
                      <td>
                        {user.stats?.totalCleanings != null ? user.stats?.totalCleanings : 0}
                      </td>
                      <td class="chat-time"><TableDate date={user.createdAt} /></td>
                    </tr>
                  );
                }}
              </For>
            </tbody>
          </table>
        </Show>
      </Show>
    </section>
  );
};
